"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var isSmallDevice = function isSmallDevice(style) {
  return (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    body.s & {\n        ", ";\n    }\n"], ["\n    body.s & {\n        ", ";\n    }\n"])), style);
};
var isMediumDevice = function isMediumDevice(style) {
  return (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    body.m & {\n        ", ";\n    }\n"], ["\n    body.m & {\n        ", ";\n    }\n"])), style);
};
var isLargeDevice = function isLargeDevice(style) {
  return (0, _styledComponents.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    body.l & {\n        ", ";\n    }\n"], ["\n    body.l & {\n        ", ";\n    }\n"])), style);
};
var isNotSmallDevice = function isNotSmallDevice(style) {
  return (0, _styledComponents.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    body:not(.s) & {\n        ", ";\n    }\n"], ["\n    body:not(.s) & {\n        ", ";\n    }\n"])), style);
};
var isNotMediumDevice = function isNotMediumDevice(style) {
  return (0, _styledComponents.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    body:not(.m) & {\n        ", ";\n    }\n"], ["\n    body:not(.m) & {\n        ", ";\n    }\n"])), style);
};
var isNotLargeDevice = function isNotLargeDevice(style) {
  return (0, _styledComponents.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    body:not(.l) & {\n        ", ";\n    }\n"], ["\n    body:not(.l) & {\n        ", ";\n    }\n"])), style);
};
var isRtlNested = function isRtlNested(style) {
  return (0, _styledComponents.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    .rtl & {\n        ", ";\n    }\n"], ["\n    .rtl & {\n        ", ";\n    }\n"])), style);
};
var rtlNested = function rtlNested() {
  return isRtlNested((0, _styledComponents.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    direction: rtl;\n"], ["\n    direction: rtl;\n"]))));
};
var themeHelpers = {
  isSmallDevice: isSmallDevice,
  isMediumDevice: isMediumDevice,
  isLargeDevice: isLargeDevice,
  isNotSmallDevice: isNotSmallDevice,
  isNotMediumDevice: isNotMediumDevice,
  isNotLargeDevice: isNotLargeDevice,
  isRtlNested: isRtlNested,
  rtlNested: rtlNested
};
var _default = themeHelpers;
exports.default = _default;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;